import { InjectionToken } from '@angular/core';
import { ReportConfig } from '../interfaces/ReportConfig';

export const REPORT_CONFIG = new InjectionToken<ReportConfig>('reportConfig');
